import fetchWithDefaults from '../CommonUtils/fetchWithDefaults';
import { urlWithParams } from '../CommonUtils/urlWithParams';

const prefix = name => `ADV.EDUCATION_CHART_GOAL.${name}`;

export const REQUEST_DATA = prefix('REQUEST_DATA');
export const RECEIVE_DATA = prefix('RECEIVE_DATA');
export const FAILED_TO_RECEIVE_DATA = prefix('FAILED_TO_RECEIVE_DATA');

export const requestData = clientId => ({
  type: REQUEST_DATA,
  clientId,
});

export const receiveData = (clientId, data, goalId) => ({
  type: RECEIVE_DATA,
  clientId,
  data,
  goalId,
});

export const failedToReceiveData = clientId => ({
  type: FAILED_TO_RECEIVE_DATA,
  clientId,
});

export const getGoalsChartList = (fpId, clientId, isPdf, goalId) => async dispatch => {
  dispatch(requestData(clientId));

  try {
    const response = await fetchWithDefaults(
      urlWithParams('/Consumer/GoalChart', {
        clientId,
        IsPdf: isPdf,
        fpId,
        goalId,
      }),
    );

    const { success, payload } = await response.json();

    if (!success) {
      return dispatch(failedToReceiveData(clientId));
    }

    const data = payload.viewData.GoalChart.Chart.Data;

    return dispatch(receiveData(clientId, data, goalId));
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }
};
